module.exports = __webpack_public_path__ + "img/quick-icon7.b884ff7c.png";